(function(){
  function num(t){return parseInt(String(t||'').replace(/[^0-9]/g,''),10)||0;}
  function run(){
    document.querySelectorAll('.product-item').forEach(function(it){
      var b=it.querySelector('.sale-box');
      if(!b||b.getAttribute('data-ml')) return;
      var p=it.querySelector('.product-item__price');
      if(!p) return;
      var s=p.querySelector('.old-price, s, del, [class*="compare"], [class*="strike"]');
      var cmp=s?num(s.textContent):0;
      var c=p.cloneNode(true);
      c.querySelectorAll('.old-price, s, del, [class*="compare"], [class*="strike"], .visually-hidden').forEach(function(e){e.remove();});
      var price=num(c.textContent.split(/[〜~\-]/)[0]);
      if(cmp>price&&price>0){
        b.textContent='-'+Math.round((1-price/cmp)*100)+'%';
        b.setAttribute('data-ml','1');
        b.classList.add('ml-sale');
      }
    });
  }
  var swMap=null,swName=null;
  function applySw(){
    if(!swMap) return;
    document.querySelectorAll('.product__selectors .radio__fieldset').forEach(function(fs){
      var lg=fs.querySelector('.radio__legend__option-name');
      if(!lg||lg.textContent.trim()!==swName) return;
      fs.querySelectorAll('.radio__button').forEach(function(rb){
        var i=rb.querySelector('input'),l=rb.querySelector('label');
        if(!i||!l||!swMap[i.value]) return;
        l.classList.add('ml-sw');
        l.style.setProperty('background-image','url("'+swMap[i.value]+'")','important');
        l.title=i.value;
      });
    });
  }
  function loadSw(){
    var m=location.pathname.match(/^(.*\/products\/[^\/?#]+)/);
    if(!m) return;
    fetch(m[1]+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(p){
      var names=['カラー','色','Color','Colour','color'];
      var opts=(p.options||[]).map(function(o){return typeof o==='string'?o:o.name;});
      var idx=-1;opts.forEach(function(o,k){if(names.indexOf(o)>-1&&idx<0)idx=k;});
      if(idx<0) return;
      swName=opts[idx];swMap={};
      (p.variants||[]).forEach(function(v){
        var val=v.options[idx];
        if(v.featured_image&&!swMap[val]){
          var src=v.featured_image.src;
          swMap[val]=src+(src.indexOf('?')>-1?'&':'?')+'width=200';
        }
      });
      applySw();
    }).catch(function(){});
  }
  function init(){
    run();
    loadSw();
    var t;
    new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){run();applySw();},150);}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
/* Yumi Hara: Japanese labels for storefront filters (labels were created in Portuguese) */
(function(){
  var MAP={'Disponibilidade':'出品状況','Preço':'価格','Disponibility':'出品状況','Availability':'出品状況','Price':'価格'};
  function fix(root){
    (root||document).querySelectorAll('[data-collection-sidebar] *, .collection__filters *').forEach(function(el){
      el.childNodes.forEach(function(n){
        if(n.nodeType===3){var t=n.nodeValue.trim();if(MAP[t]){n.nodeValue=n.nodeValue.replace(t,MAP[t]);}}
      });
    });
  }
  function init(){fix();var s=document.querySelector('[data-collection-sidebar]')||document.querySelector('.collection__products');if(s&&window.MutationObserver){new MutationObserver(function(){fix();}).observe(s,{childList:true,subtree:true});}}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
